import { useEffect, useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';

function walletLabel(canMakePaymentResult) {
  if (!canMakePaymentResult) return null;
  const wallets = [
    canMakePaymentResult.applePay && 'Apple Pay',
    canMakePaymentResult.googlePay && 'Google Pay',
  ].filter(Boolean);
  return wallets.length ? wallets.join(' & ') : null;
}

export default function useWalletLabel({ stripePublishableKey, stripeConnectedAccountId, paymentCountry, paymentCurrency }) {
  const [label, setLabel] = useState(null);

  useEffect(() => {
    if (!stripePublishableKey || !paymentCountry || !paymentCurrency) return undefined;
    let active = true;
    loadStripe(stripePublishableKey, stripeConnectedAccountId ? { stripeAccount: stripeConnectedAccountId } : undefined)
      .then((stripe) => stripe && stripe.paymentRequest({
        country: paymentCountry,
        currency: paymentCurrency,
        total: { label: 'Total', amount: 0 },
      }).canMakePayment())
      .then((result) => { if (active) setLabel(walletLabel(result)); })
      .catch(() => { if (active) setLabel(null); });
    return () => { active = false; };
  }, [stripePublishableKey, stripeConnectedAccountId, paymentCountry, paymentCurrency]);

  return label;
}
